import { FaLaptop, FaUserShield, FaChartLine, FaBan, FaTools } from 'react-icons/fa';

export default function UsagePolicy() {
  return (
    <div className="min-h-screen ">
      {/* Header */}
      <header className=" ">
        <div className="container mx-auto px-6 py-8">
          <div className="flex items-center justify-between">
            <div className="text-3xl font-bold text-gray-800">
              <span className="text-[#FD5F20]">ATO</span> Creative
            </div>
            <div className="text-sm text-gray-500">Effective: {new Date().toLocaleDateString()}</div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-[#FD5F20] text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <div className="flex justify-center mb-6">
            <FaLaptop className="text-5xl" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Website & Services Usage Policy</h1>
          <p className="text-xl max-w-3xl mx-auto opacity-90">
            Guidelines for proper use of our digital assets and marketing services
          </p>
        </div>
      </section>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaUserShield className="text-[#FD5F20] mr-3" />
              Proper Use of Our Services
            </h2>
            <p className="text-gray-600 mb-4">
              This Usage Policy outlines acceptable practices when using ATO Creative's website, tools, and marketing services. By accessing our resources, you agree to comply with these guidelines.
            </p>
          </section>

          {/* Acceptable Use */}
          <section className="mb-16  p-8 rounded-xl ">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaChartLine className="text-[#FD5F20] mr-3" />
              Acceptable Use
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-[#FD5F20] bg-opacity-5 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-gray-800 mb-3">For Clients</h3>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Accessing your account and marketing analytics
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Downloading approved marketing assets
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Requesting legitimate service modifications
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Providing constructive feedback
                  </li>
                </ul>
              </div>
              <div className="bg-[#FD5F20] bg-opacity-5 p-6 rounded-lg">
                <h3 className="font-semibold text-lg text-gray-800 mb-3">For Visitors</h3>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Browsing our service offerings
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Contacting us for information
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Sharing content via social buttons
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#FD5F20] mr-2">•</span>
                    Subscribing to newsletters
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Prohibited Activities */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaBan className="text-[#FD5F20] mr-3" />
              Prohibited Activities
            </h2>
            <div className=" p-8 rounded-xl ">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <div className="flex items-start mb-4">
                    <div className="bg-[#FD5F20] bg-opacity-10 p-2 rounded-full mr-3">
                      <span className="text-[#FD5F20] font-bold">1</span>
                    </div>
                    <p className="text-gray-600">
                      <span className="font-semibold">Unauthorized Access:</span> Attempting to access non-public systems or client data
                    </p>
                  </div>
                  <div className="flex items-start mb-4">
                    <div className="bg-[#FD5F20] bg-opacity-10 p-2 rounded-full mr-3">
                      <span className="text-[#FD5F20] font-bold">2</span>
                    </div>
                    <p className="text-gray-600">
                      <span className="font-semibold">Service Abuse:</span> Overloading systems with automated requests
                    </p>
                  </div>
                </div>
                <div>
                  <div className="flex items-start mb-4">
                    <div className="bg-[#FD5F20] bg-opacity-10 p-2 rounded-full mr-3">
                      <span className="text-[#FD5F20] font-bold">3</span>
                    </div>
                    <p className="text-gray-600">
                      <span className="font-semibold">Content Misuse:</span> Scraping or redistributing our proprietary materials
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="bg-[#FD5F20] bg-opacity-10 p-2 rounded-full mr-3">
                      <span className="text-[#FD5F20] font-bold">4</span>
                    </div>
                    <p className="text-gray-600">
                      <span className="font-semibold">False Representation:</span> Impersonating ATO Creative or our clients
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Service-Specific Rules */}
          <section className="mb-16  p-8 rounded-xl ">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaTools className="text-[#FD5F20] mr-3" />
              Service-Specific Guidelines
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Content Management</h3>
                  <p className="text-gray-600">
                    Clients must provide accurate information and obtain necessary rights for all materials submitted for campaigns.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Reporting Access</h3>
                  <p className="text-gray-600">
                    Analytics dashboards are for internal business use only. Redistribution to third parties requires written consent.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">3</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">API Usage</h3>
                  <p className="text-gray-600">
                    Any automated access to our systems must be pre-approved and follow published rate limits.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Enforcement */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Policy Enforcement</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-[#FD5F20] bg-opacity-5 p-6 rounded-lg text-center">
                <div className="text-[#FD5F20] text-2xl font-bold mb-2">1</div>
                <h3 className="font-semibold text-gray-800 mb-2">Warning</h3>
                <p className="text-gray-600 text-sm">
                  First violations may result in a warning and temporary suspension
                </p>
              </div>
              <div className="bg-[#FD5F20] bg-opacity-5 p-6 rounded-lg text-center">
                <div className="text-[#FD5F20] text-2xl font-bold mb-2">2</div>
                <h3 className="font-semibold text-gray-800 mb-2">Service Suspension</h3>
                <p className="text-gray-600 text-sm">
                  Repeated violations lead to account suspension
                </p>
              </div>
              <div className="bg-[#FD5F20] bg-opacity-5 p-6 rounded-lg text-center">
                <div className="text-[#FD5F20] text-2xl font-bold mb-2">3</div>
                <h3 className="font-semibold text-gray-800 mb-2">Legal Action</h3>
                <p className="text-gray-600 text-sm">
                  Severe breaches may result in termination and legal recourse
                </p>
              </div>
            </div>
          </section>

          
        </div>
      </main>

     
    </div>
  );
}